// extracted by css-extract-rspack-plugin
export default {"wallpaperName":"src-modules-desktop-components-WallpapersSelector-components-WallpaperItem-WallpaperItem-module__wallpaperName-H9rX4O","animatedBadge":"src-modules-desktop-components-WallpapersSelector-components-WallpaperItem-WallpaperItem-module__animatedBadge-POmRvn"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"wallpaperName\":\"src-modules-desktop-components-WallpapersSelector-components-WallpaperItem-WallpaperItem-module__wallpaperName-H9rX4O\",\"animatedBadge\":\"src-modules-desktop-components-WallpapersSelector-components-WallpaperItem-WallpaperItem-module__animatedBadge-POmRvn\"}";
        // 1793875576821
        var cssReload = require("../../../../../../../node_modules/.pnpm/@rspack+core@1.5.8_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  